/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

import Mustache from 'mustache';

import Autocomplete from "@js/modules/map/Autocomplete";
import FindMarker from '@js/modules/map/FindMarker';
import Maps from '@js/modules/map/Maps';

// Search
window.SEARCH =
    window.SEARCH ||
    new (function SEARCH() {
        this.modules = {
            // ClearFilters: ClearFilters,
            FindMarker: FindMarker,
            Maps: Maps,
        };

        let searchInfoWindowTemplate = null;

        // After the map has been initialized
        // Attach your callback function to the `window` object
        window.mapReady = () => {
            console.log('Call window.mapReady');

            if (!document.getElementById('salon-map')) {
                console.log('No map element');
                return false;
            }

            // Get map object
            this.modules.Maps.getMap('salon-map');

            // Map styles
            // const mapStyleSet = [{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","stylers":[{"saturation":-100},{"lightness":20}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","stylers":[{"saturation":-100},{"lightness":5}]},{"featureType":"poi.park","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","stylers":[{"saturation":-100},{"lightness":5}]},{"featureType":"poi.school","stylers":[{"saturation":-100},{"lightness":5}]},{"featureType":"road.highway","stylers":[{"visibility":"simplified"},{"weight":1}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#c1d1d7"},{"weight":1}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#000000"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","stylers":[{"saturation":-100},{"lightness":5}]}];
            const mapStyleSet = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];

            // Style the map
            window.map.styles(mapStyleSet);

            // TODO: Is this needed at this point as we init the template later on
            if (typeof marker !== 'undefined') {
                google.maps.event.addListener(marker, 'click', () => {
                    let rendered = Mustache.render(searchInfoWindowTemplate, data);

                    // Create info window
                    const infowindow = new google.maps.InfoWindow({
                        content: rendered,
                    });
                    // Open info window
                    infowindow.open(window.map, this);
                });
            }
        };

        // Reinitalise search
        window.reinitSearch = () => {
            this.modules.Maps.initMap('salon-map', window.mapReady);

            window.SUSTAINABLESALONS.modules.Autocomplete.activateSalonLocator();

            // Reinit markers
            this.modules.FindMarker.setup();
        };


        // Marker click event
        window.mapMarkerClick = (markerId, forceOpen = false) => {
            console.log('FUNCTION: window.mapMarkerClick');

            // Get the DynamicMap object
            let map = window.map;

            // Open the info window of specified marker
            function forceOpenTrigger(markerId) {
                // Close all, open specified info window
                window.map
                    .closeInfoWindow('*', true) // Close all info windows
                    .openInfoWindow(markerId) // Open specified info window
                ;
            }

            // If the info window already exists
            if (map._infoWindows[markerId]) {
                // Force marker to open
                if (forceOpen) {
                    forceOpenTrigger(markerId);
                }

                // Bail and open normally
                return;
            }

            // Log status
            console.log(`[${map.id}] Adding info window to marker "${markerId}"`);

            // Close all info windows
            map.closeInfoWindow('*', true);

            // Get entry ID
            let entryId = markerId.split('-')[0];

            // Put URL together
            let url = '/api/v1/salon.json?id='+entryId;

            console.log('Get data from ', url);

            // Get data from API
            fetch(url)
                .then(response => response.json())
                .then(data => {

                    // If an error occurred, log warning
                    if (data.error) {
                        console.warn(data.error.message);
                    }

                    let rendered = Mustache.render(searchInfoWindowTemplate, data);

                    console.log(data);

                    // Create info window
                    let infowindow = new google.maps.InfoWindow({
                        content: rendered
                    });

                    // Get the marker
                    let marker = map.getMarker(markerId, true);

                    // Attach info window to map and marker
                    infowindow.open({
                        map: map._map,
                        anchor: marker
                    });

                    // Store info window for future use
                    map._infoWindows[markerId] = infowindow;

                    // Add click event to marker
                    google.maps.event.addListener(marker, 'click', function() {
                        // Close all info windows
                        map.closeInfoWindow('*', true);
                        // Open info window for this marker
                        map.openInfoWindow(markerId);
                    });

                    if (forceOpen) {
                        forceOpenTrigger(markerId);
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        };

        // Overrides the request class (default is `htmx-request`)
        htmx.config.requestClass = 'loading';

        // Reinit search after swap
        htmx.on('htmx:afterSettle', function(event) {
            window._gmData.infoWindows['salon-map'] = {};
            window.reinitSearch();

            // Scroll to top of search content so we aren't left at the bottom of the new page
            const searchResultsEl = document.getElementById('search');
            if (searchResultsEl) {
                window.scrollTo(0, window.innerWidth < 768 ? 370 : 530);
            }

            // Update lazyload
            window.lazyLoadInstance.update();
        });

        // DOM load
        document.addEventListener('DOMContentLoaded', e => {
            if (config.salonInfoWindow) {
                fetch(config.salonInfoWindow)
                    .then((response) => response.text())
                    .then((template) => {
                        searchInfoWindowTemplate = template;

                        // Parse for use later on
                        Mustache.parse(searchInfoWindowTemplate);
                    });
            }
        });
    })();
